<template>
    <div id="w_post_visitors_report">
        <div class="col-lg-10 content-title pl-lg-3 mt-1 mb-3 d-none">
            <h2 class="content-title">Napi látogatás</h2>
            <p>Átirányítás a Google Analytics-re...</p>
        </div>
        <ReportFilters :data="data"></ReportFilters>
        <Report :data="data"></Report>
    </div>
</template>

<script>
    import ReportFilters from '../../components/reports/ReportFilters'
    import Report from '../../components/reports/Reports'

    export default{
        name: 'w_post_visitors_report',
        data() {
            return {
                data: {
                    type: 'post_visitors',
                    name: 'Cikk látogatás',
                    path: '/reports/post-visitors',
                    show_summary: true,
                    filters: {
                        menu_id: 1,
                        visitor_type: '',
                        post_type: '',
                        date_from: '',
                        date_to: '',
                        user_id: '',
                    }
                }
            }
        },
        components: {
            ReportFilters,
            Report
        },
        mounted() {
            window.location.href = 'https://analytics.google.com/analytics/web/';
        }
    }
</script>
